import { listenMessageEvent } from '.';
import PostMessageType from '../constants/postMessageTypes';
import WindowManager, { ChangeTarget } from './windowManager';

type ShowStatusParams = {
  secondaryStatus?: string;
  timeoutMs?: number;
};

export async function showStatus({
  secondaryStatus,
  timeoutMs,
}: ShowStatusParams): Promise<void> {
  return new Promise((resolve) => {
    WindowManager.openIndirect({
      secondaryStatus,
      changeOnly: ChangeTarget.SECONDARY,
    });

    let timeoutId: ReturnType<typeof setTimeout>;
    // Set close event listener
    const onUserCancellation = listenMessageEvent(
      PostMessageType.USER_CANCELLED,
    );

    // Cancel both timeout and event listener
    function resolveAfterCancel() {
      if (timeoutId !== undefined) {
        clearTimeout(timeoutId);
      }
      onUserCancellation.cancel();

      WindowManager.closeSecondary();

      resolve();
    }
    onUserCancellation.promise.then(resolveAfterCancel);

    // Set timeout,if needed
    if (timeoutMs > 0) {
      timeoutId = setTimeout(resolveAfterCancel, timeoutMs);
    }
  });
}
